export const RESOLUTION_OPTIONS = {
  AUTO: {
    label: 'Авто',
    value: 0,
  },
  ONE_IN_ROW: {
    label: '1x1',
    value: 1,
  },
  TWO_IN_ROW: {
    label: '2x2',
    value: 2,
  },
  THREE_IN_ROW: {
    label: '3x3',
    value: 3,
  },
  FOR_IN_ROW: {
    label: '4x4',
    value: 4,
  },
};
